"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/underwriting-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Funderwriting-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderwritingTestApiServiceClient = exports.SetProductBlockResponse = exports.SetProductBlockRequestRemoveBlockReasons = exports.SetProductBlockRequestAppendBlockReasons = exports.SetProductBlockRequest = exports.SetUserEligibilityResponse = exports.SetUserEligibilityRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const borrow_block_reason_1 = require("../common/borrow-block-reason");
const flex_eligibility_1 = require("../underwriting/flex-eligibility");
const product_type_1 = require("../underwriting/product-type");
const underwriting_testing_service_1 = require("../underwriting/testing/underwriting-testing-service");
const protobufPackage = 'com.step.testapi.underwriting.proto';
function createBaseSetUserEligibilityRequest() {
    return { userId: '', eligibility: undefined };
}
exports.SetUserEligibilityRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.eligibility)) {
            message.eligibility = flex_eligibility_1.FlexEligibility.fromJSON(object.eligibility);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.eligibility !== undefined) {
            obj.eligibility = flex_eligibility_1.FlexEligibility.toJSON(message.eligibility);
        }
        return obj;
    },
    create(base) {
        return exports.SetUserEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetUserEligibilityRequest();
        message.userId = object.userId ?? '';
        message.eligibility = (object.eligibility !== undefined && object.eligibility !== null)
            ? flex_eligibility_1.FlexEligibility.fromPartial(object.eligibility)
            : undefined;
        return message;
    },
};
function createBaseSetUserEligibilityResponse() {
    return {};
}
exports.SetUserEligibilityResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetUserEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetUserEligibilityResponse();
        return message;
    },
};
function createBaseSetProductBlockRequest() {
    return {
        userId: '',
        productType: product_type_1.ProductType.INVALID_PRODUCT_TYPE,
        blockReasons: [],
        append: undefined,
        remove: undefined,
    };
}
exports.SetProductBlockRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            productType: isSet(object.productType)
                ? (0, product_type_1.productTypeFromJSON)(object.productType)
                : product_type_1.ProductType.INVALID_PRODUCT_TYPE,
        };
        if (globalThis.Array.isArray(object?.blockReasons)) {
            message.blockReasons = object.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonFromJSON)(e));
        }
        if (isSet(object.append)) {
            message.append = exports.SetProductBlockRequestAppendBlockReasons.fromJSON(object.append);
        }
        if (isSet(object.remove)) {
            message.remove = exports.SetProductBlockRequestRemoveBlockReasons.fromJSON(object.remove);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.productType !== product_type_1.ProductType.INVALID_PRODUCT_TYPE) {
            obj.productType = (0, product_type_1.productTypeToJSON)(message.productType);
        }
        if (message.blockReasons?.length) {
            obj.blockReasons = message.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonToJSON)(e));
        }
        if (message.append !== undefined) {
            obj.append = exports.SetProductBlockRequestAppendBlockReasons.toJSON(message.append);
        }
        if (message.remove !== undefined) {
            obj.remove = exports.SetProductBlockRequestRemoveBlockReasons.toJSON(message.remove);
        }
        return obj;
    },
    create(base) {
        return exports.SetProductBlockRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetProductBlockRequest();
        message.userId = object.userId ?? '';
        message.productType = object.productType ?? product_type_1.ProductType.INVALID_PRODUCT_TYPE;
        message.blockReasons = object.blockReasons?.map((e) => e) || [];
        message.append = (object.append !== undefined && object.append !== null)
            ? exports.SetProductBlockRequestAppendBlockReasons.fromPartial(object.append)
            : undefined;
        message.remove = (object.remove !== undefined && object.remove !== null)
            ? exports.SetProductBlockRequestRemoveBlockReasons.fromPartial(object.remove)
            : undefined;
        return message;
    },
};
function createBaseSetProductBlockRequestAppendBlockReasons() {
    return { blockReasons: [] };
}
exports.SetProductBlockRequestAppendBlockReasons = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.blockReasons)) {
            message.blockReasons = object.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.blockReasons?.length) {
            obj.blockReasons = message.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.SetProductBlockRequestAppendBlockReasons.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetProductBlockRequestAppendBlockReasons();
        message.blockReasons = object.blockReasons?.map((e) => e) || [];
        return message;
    },
};
function createBaseSetProductBlockRequestRemoveBlockReasons() {
    return { blockReasons: [] };
}
exports.SetProductBlockRequestRemoveBlockReasons = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.blockReasons)) {
            message.blockReasons = object.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.blockReasons?.length) {
            obj.blockReasons = message.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.SetProductBlockRequestRemoveBlockReasons.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetProductBlockRequestRemoveBlockReasons();
        message.blockReasons = object.blockReasons?.map((e) => e) || [];
        return message;
    },
};
function createBaseSetProductBlockResponse() {
    return {};
}
exports.SetProductBlockResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetProductBlockResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetProductBlockResponse();
        return message;
    },
};
/**
 * Underwriting Test API Service
 */
class UnderwritingTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.underwriting.proto.UnderwritingTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'GetApplication',
            requestType: underwriting_testing_service_1.GetApplicationRequest,
            responseType: underwriting_testing_service_1.GetApplicationResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetUserEligibility',
            requestType: exports.SetUserEligibilityRequest,
            responseType: exports.SetUserEligibilityResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetProductBlock',
            requestType: exports.SetProductBlockRequest,
            responseType: exports.SetProductBlockResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetApplicationStatus',
            requestType: underwriting_testing_service_1.SetApplicationStatusRequest,
            responseType: underwriting_testing_service_1.SetApplicationStatusResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetApplicationProducts',
            requestType: underwriting_testing_service_1.SetApplicationProductsRequest,
            responseType: underwriting_testing_service_1.SetApplicationProductsResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetCreditAgencyData',
            requestType: underwriting_testing_service_1.SetCreditAgencyDataRequest,
            responseType: underwriting_testing_service_1.SetCreditAgencyDataResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetCreditAgencyData',
            requestType: underwriting_testing_service_1.GetCreditAgencyDataRequest,
            responseType: underwriting_testing_service_1.GetCreditAgencyDataResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetCreditScoreReasons',
            requestType: underwriting_testing_service_1.GetCreditScoreReasonsRequest,
            responseType: underwriting_testing_service_1.GetCreditScoreReasonsResponse,
            authenticationOptions: undefined,
        }, {
            name: 'WithdrawApplication',
            requestType: underwriting_testing_service_1.WithdrawApplicationRequest,
            responseType: underwriting_testing_service_1.WithdrawApplicationResponse,
            authenticationOptions: undefined,
        }, {
            name: 'ResetReapplyCooldown',
            requestType: underwriting_testing_service_1.ResetReapplyCooldownRequest,
            responseType: underwriting_testing_service_1.ResetReapplyCooldownResponse,
            authenticationOptions: undefined,
        }, {
            name: 'UpdateTestUser',
            requestType: underwriting_testing_service_1.UpdateTestUserRequest,
            responseType: underwriting_testing_service_1.UpdateTestUserResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetTestUser',
            requestType: underwriting_testing_service_1.GetTestUserRequest,
            responseType: underwriting_testing_service_1.GetTestUserResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get underwriting application
     */
    getApplication(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set the eligibility for a user
     */
    setUserEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set borrowing product block reasons for a user.
     */
    setProductBlock(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set application status
     */
    setApplicationStatus(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set application products
     */
    setApplicationProducts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set credit agency data.
     */
    setCreditAgencyData(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the credit agency data for the user.
     */
    getCreditAgencyData(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a map of credit score reason codes to descriptions.
     */
    getCreditScoreReasons(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Withdraws last application for the user.
     */
    withdrawApplication(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Resets the reapply cool-down for the user, allowing the user to reapply for
     * credit line immediately.
     */
    resetReapplyCooldown(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update test underwriting user
     */
    updateTestUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get test underwriting user
     */
    getTestUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[11],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.UnderwritingTestApiServiceClient = UnderwritingTestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=underwriting-testapi-service.js.map